import Translations from '../../utils/Translations';
import PropTypes from 'prop-types';
import { Component } from 'react';
// Embed Video
const EMBED_SIZE_ONE_WIDTH = '640';
const EMBED_SIZE_ONE_HEIGHT = '360';
const EMBED_SIZE_ONE_ID = '1';

const EMBED_SIZE_TWO_WIDTH = '853';
const EMBED_SIZE_TWO_HEIGHT = '480';
const EMBED_SIZE_TWO_ID = '2';

const EMBED_SIZE_THREE_WIDTH = '1200';
const EMBED_SIZE_THREE_HEIGHT = '675';
const EMBED_SIZE_THREE_ID = '3';

class SocialShareBarEmbedContent extends Component {
	constructor(props) {
		super(props);
		// Default Values
		this.state = {
			selectedSize: EMBED_SIZE_ONE_ID,
			embedWidth: EMBED_SIZE_ONE_WIDTH,
			embedHeight: EMBED_SIZE_ONE_HEIGHT,
		};

		this.handleSelect = this.handleSelect.bind(this);
	}

	handleSelect(event) {
		const newState = event.target.value;

		switch (newState) {
			case EMBED_SIZE_ONE_ID:
				this.setState({ selectedSize: newState, embedWidth: EMBED_SIZE_ONE_WIDTH, embedHeight: EMBED_SIZE_ONE_HEIGHT });
				break;
			case EMBED_SIZE_TWO_ID:
				this.setState({ selectedSize: newState, embedWidth: EMBED_SIZE_TWO_WIDTH, embedHeight: EMBED_SIZE_TWO_HEIGHT });
				break;
			case EMBED_SIZE_THREE_ID:
				this.setState({ selectedSize: newState, embedWidth: EMBED_SIZE_THREE_WIDTH, embedHeight: EMBED_SIZE_THREE_HEIGHT });
				break;

			default:
				break;
		}
	}

	// Define Content of Embed-Tab
	render() {
		const iframeUrl = this.props.embedBaseUrl + this.props.videoId;

		const iframe =
			"<iframe src='" +
			iframeUrl +
			"' frameborder='0' width='" +
			this.state.embedWidth +
			"' height='" +
			this.state.embedHeight +
			"' scrolling='no' allowfullscreen " +
			'></iframe>';

		const embedVideo = (
			<div>
				<div className="social-share-bar social-share-bar__div embed">
					<label htmlFor="embedSizeSelect" className="social-share-bar__label">
						{Translations.get('SocialShareEmbedSize')}
					</label>
					<select id="embedSizeSelect" className="social-share-bar__select" value={this.state.selectedSize} onChange={this.handleSelect}>
						<option className="social-share-bar__select option" value={EMBED_SIZE_ONE_ID}>
							{' '}
							{EMBED_SIZE_ONE_WIDTH} x {EMBED_SIZE_ONE_HEIGHT}
						</option>
						<option className="social-share-bar__select option" value={EMBED_SIZE_TWO_ID}>
							{' '}
							{EMBED_SIZE_TWO_WIDTH} x {EMBED_SIZE_TWO_HEIGHT}
						</option>
						<option className="social-share-bar__select option" value={EMBED_SIZE_THREE_ID}>
							{' '}
							{EMBED_SIZE_THREE_WIDTH} x {EMBED_SIZE_THREE_HEIGHT}
						</option>
					</select>
				</div>
				<table>
					<tr>
						<td className="social-share-bar__textarea embed"> {iframe}</td>
					</tr>
				</table>
			</div>
		);

		const tabContent = <div className="social-share-bar__tabcontent"> {embedVideo}</div>;

		return <div>{tabContent}</div>;
	}
}

SocialShareBarEmbedContent.propTypes = {
	videoId: PropTypes.string,
	embedBaseUrl: PropTypes.string,
};

export default SocialShareBarEmbedContent;
